import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Box, Divider, Grid, Stack, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../store/reduxHooks';
import { useRenewTokenMutation } from '../../../services/rtkQueryServices';
import { FileUpload } from '../../../components/FileUpload';

function UserInfo(user: any) {
  if (!user) {
    return <div></div>;
  }
  const fallbackImage = ({ currentTarget }: any) => {
    currentTarget.onerror = null; // prevents looping
    currentTarget.src = '/images/userProfile.jpeg';
  };
  return (
    <Box display={'flex'} sx={{ flexDirection: 'column', gap: 5 }}>
      {user.displayName || 'no display name'}
      {user.email}
      <img
        src={
          user.displayName
            ? '/api/admin/v1/file/profile/' + user.displayName
            : ''
        }
        width={150}
        onError={fallbackImage}
      />
      {user.isVerified ? 'User is verified' : 'User is not verified'}

      {/* {props.user.isVerified === false ? 'you need to confirm your email' : ''} */}
    </Box>
  );
}

export default function ProfilePage(props: any) {
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(0);
  const { user, token } = useAppSelector((state) => state.auth);
  const [images, setImages] = useState<any>([]);
  const [renewToken, { isLoading }] = useRenewTokenMutation({});

  const uploadSuccess = () => {
    renewToken({ body: {} });
  };

  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12}>
          <Typography variant='h4' mb={1}>
            Profile
          </Typography>
          <Divider />
          <UserInfo {...user} />
          <FileUpload
            token={token}
            uploadUrl='/api/admin/v1/file/upload'
            onSuccess={uploadSuccess}
          />
          {images.map((imgUrl: any) => (
            <img src={imgUrl} />
          ))}
        </Grid>
      </Grid>
    </>
  );
}
